import type { ReactNode } from 'react';

export const symbol_trail_length_medium: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M305-280q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h193q-21-21-36-49.5T441.81-450H230q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h211.81q5.19-29 19.69-59.5T498-620H310q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h330q83 0 141.5 58.5T840-480q0 83-58.5 141.5T640-280H305Zm334.76-60Q698-340 739-380.76q41-40.77 41-99Q780-538 739.24-579q-40.77-41-99-41Q582-620 541-579.24q-41 40.77-41 99Q500-422 540.76-381q40.77 41 99 41ZM150-280q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h65q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-65Zm490-200Z"
		/>
	</svg>
);
